import { render, staticRenderFns } from "./client-form.vue?vue&type=template&id=78258dfa&scoped=true&lang=pug&"
import script from "./client-form.vue?vue&type=script&lang=ts&"
export * from "./client-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78258dfa",
  null
  
)

export default component.exports